import { render, staticRenderFns } from "./highlighted_button.vue?vue&type=template&id=12895701&"
import script from "./highlighted_button.vue?vue&type=script&lang=js&"
export * from "./highlighted_button.vue?vue&type=script&lang=js&"
import style0 from "./highlighted_button.vue?vue&type=style&index=0&id=12895701&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports